import {
  BuildingIcon,
  PersonIcon,
  FileIcon,
  AlertIcon,
  ReviewIcon,
  CheckIcon,
  ClockIconV2,
  ArrowGrowIcon,
  ClockIcon,
  ProcessingFlowIcon,
  EyeIcon,
  RupeeIcon,
} from "../../images/icons/icons";
import { convertThenFormat1 } from "../common-data/Converts";

export const mockStats = {
  totalGyms: 3,
  totalEmployees: 24,
  totalPayout: 674518,
  pendingApprovals: 9,
};

export const payrollTabs = [
  {
    label: "Gym Overview",
    value: "gym-overview",
    icon: <BuildingIcon />,
  },
  {
    label: "Overview",
    value: "overview",
    icon: <PersonIcon />,
  },
  {
    label: "Employees",
    value: "employees",
    icon: <FileIcon />,
  },
  {
    label: "Discrepancies",
    value: "discrepancies",
    icon: <AlertIcon />,
  },
  {
    label: "Processing Flow",
    value: "processing-flow",
    icon: <ProcessingFlowIcon />,
  },
  {
    label: "Bulk Process",
    value: "bulk-process",
    icon: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
        <path d="m9 11 3 3L22 4" />
      </svg>
    ),
  },
  // {
  //   label: "Bank Files",
  //   value: "bank-files",
  //   icon: (
  //     <svg
  //       width="24"
  //       height="24"
  //       viewBox="0 0 24 24"
  //       fill="none"
  //       stroke="currentColor"
  //       strokeWidth="2"
  //       strokeLinecap="round"
  //       strokeLinejoin="round"
  //     >
  //       <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
  //       <polyline points="7,10 12,15 17,10" />
  //       <line x1="12" x2="12" y1="15" y2="3" />
  //     </svg>
  //   ),
  // },
  {
    label: "History",
    value: "history",
    icon: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M8 2v4" />
        <path d="M16 2v4" />
        <rect width="18" height="18" x="3" y="4" rx="2" />
        <path d="M3 10h18" />
      </svg>
    ),
  },
];

export const getStatsIcon = (key) => {
  const iconMap = {
    total_gym: <BuildingIcon color="#2563eb" />,
    total_employees: <PersonIcon color="#16a34a" />,
    total_payout: <RupeeIcon color="#9333ea" />,
    total_pending_approvals: <AlertIcon color="#d97706" />,
    employees_count: <PersonIcon color="#16a34a" />,
    processed_count: <CheckIcon color="#16a34a" />,
    pending_count: <ClockIconV2 color="#d97706" />,
    issues_count: <AlertIcon color="#dc2626" />,
    gross_salary: <RupeeIcon color="#9333ea" />,
    total_deduction_sum: <ArrowGrowIcon color="#dc2626" />,
    net_payout: <RupeeIcon color="#16a34a" />,
    avg_attendance_day: <ClockIcon color="#d97706" />,
    open_issue: <AlertIcon color="#dc2626" />,
    resolved: <CheckIcon color="#16a34a" />,
    resolve_percent: <ClockIcon color="#d97706" />,
  };

  return iconMap[key] || <BuildingIcon color="#6b7280" />;
};

export const getStatsBgColor = (key) => {
  const bgColorMap = {
    total_gym: "#dbeafe",
    total_employees: "#dcfce7",
    total_payout: "#f3e8ff",
    total_pending_approvals: "#fef3c7",
    employees_count: "#dcfce7",
    processed_count: "#dcfce7",
    pending_count: "#fef3c7",
    issues_count: "#fee2e2",
    gross_salary: "#f3e8ff",
    total_deduction_sum: "#fee2e2",
    net_payout: "#dcfce7",
    avg_attendance_day: "#fef3c7",
    open_issue: "#fee2e2",
    resolved: "#dcfce7",
    resolve_percent: "#fef3c7",
  };

  return bgColorMap[key] || "#f3f4f6";
};

export const getStatsTextColor = (key) => {
  const bgColorMap = {
    pending_approval: "#d97706",
    ready_to_process: "#16a34a",
    total_selected_employees: "#16a34a",
    total_processed_employees: "#7c3aed",
    total_payout: "#16a34a",
    total_eligible_employees: "#2563eb",
    deduction: "#dc2626",
    avg_users_per_month: "#2563eb",
    total: "#7c3aed",
  };

  return bgColorMap[key] || "#000";
};

export const getMetricId = (key) => {
  const idMap = {
    total_gym: "gyms",
    total_employees: "employees",
    total_eligible_employees: "pp-eligible",
    total_selected_employees: "pp-selected",
    total_processed_employees: "pp-processed",
    total_payout: "pp-payout",

    present: "pp-green-badge",
    absent: "pp-red-badge",
    leave: "pp-red-badge",
    halfday: "pp-blue-badge",
  };

  return idMap[key] || key;
};

export const getAriaLabel = (label, value) => `${label}: ${value}`;

export const getStatsLabel = (key) => {
  const labelMap = {
    total_gym: "Total Gyms",
    total_employees: "Total Employees",
    total_payout: "Total Payout",
    total_pending_approvals: "Pending Approvals",
    total_deduction_sum: "Total Deductions",
    avg_attendance_day: "Avg Attendance",
    total_eligible_employees: "Eligible",
    total_selected_employees: "Selected",
    total_processed_employees: "Total Processed Employees",
    deduction: "Total Deduction",
    avg_users_per_month: "Avg Employees",
  };

  return (
    labelMap[key] ||
    key.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase())
  );
};

export const getStatsSubLabel = (key, isHistory = false) => {
  const labelMap = {
    total_eligible_employees: "employees",
    total_selected_employees: "employees",
    total_processed_employees: "employees",
    total_payout: isHistory ? "this period" : "for selected",
    deduction: "this period",
    avg_users_per_month: "per month",
    total: "Records",
  };

  return (
    labelMap[key] ||
    key.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase())
  );
};

export const formatStatsValue = (key = "", value = 0) => {
  if (
    key === "total_payout" ||
    key === "total_deduction_sum" ||
    key === "deduction"
  ) {
    return `₹${convertThenFormat1(value)}`;
  } else if (
    key === "avg_users_per_month" ||
    key === "total" ||
    key === "total_processed_employees" ||
    key === "total_selected_employees" ||
    key === "total_eligible_employees" ||
    key === "total_employee" ||
    key === "pending_approval" ||
    key === "ready_to_process" ||
    key === "open_issue" ||
    key === "resolved" ||
    key === "total_gym" ||
    key === "total_employees" ||
    key === "total_pending_approvals" ||
    key === "employees_count" ||
    key === "avg_attendance_day"
  ) {
    return Math.round(value);
  } else if (key === "resolve_percent") {
    return `${Math.round(value)}%`;
  }

  return convertThenFormat1(value);
};

export const getGymStatus = (issueCount, pendingCount) => {
  const issues = Number(issueCount) || 0;
  const pending = Number(pendingCount) || 0;
  return issues > 0 || pending > 0 ? "Overdue" : "Active";
};

export const calculateProgress = (processed, total) => {
  if (!total || total === 0) return 0;
  return Math.round((processed / total) * 100);
};

export const getOverallStatus = (gymsData) => {
  if (!gymsData || gymsData.length === 0) return "No Data";

  const hasOverdue = gymsData.some((gym) => {
    const issues = Number(gym.issue_count) || 0;
    const pending = Number(gym.pending_count) || 0;
    return issues > 0 || pending > 0;
  });

  return hasOverdue ? "Overdue" : "On Track";
};

export const renderActionButton = (row, isStaff, handleModalClick) => {
  const userApproval = row?.user_approval;
  const stackholderApproval = row?.stack_holder_approval;
  // const approvalRequestSent = row?.approval_request_send;

  const viewPayrollButton = (
    <button
      key="view-payroll"
      type="button"
      className="pp-employee-payroll-action-button pp-outlined-border"
      onClick={() => handleModalClick(row, "view-payroll")}
      style={{ marginRight: "8px" }}
    >
      <EyeIcon />
      View
    </button>
  );

  let actionButton = null;

  if (isStaff) {
    if (userApproval === "pending") {
      actionButton = (
        <button
          key="review"
          type="button"
          className="pp-employee-payroll-action-button pp-dark-badge"
          onClick={() => handleModalClick(row, "staff")}
        >
          <ReviewIcon />
          Review
        </button>
      );
    } else if (userApproval === "rejected") {
      actionButton = (
        <button
          key="rejected"
          type="button"
          className="pp-employee-payroll-action-button pp-transparent-badge disabled"
          style={{ color: "#dc2626" }}
          disabled
        >
          Staff Rejected
        </button>
      );
    } else if (userApproval === "approved") {
      if (stackholderApproval === "pending") {
        actionButton = (
          <button
            key="hr-pending"
            type="button"
            className="pp-employee-payroll-action-button pp-transparent-badge disabled"
            style={{ color: "#eab308" }}
            disabled
          >
            HR Approval Pending
          </button>
        );
      } else if (stackholderApproval === "rejected") {
        actionButton = (
          <button
            key="hr-rejected"
            type="button"
            className="pp-employee-payroll-action-button pp-transparent-badge disabled"
            style={{ color: "#dc2626" }}
            disabled
          >
            HR Rejected
          </button>
        );
      } else if (stackholderApproval === "approved") {
        actionButton = (
          <button
            key="hr-approved"
            type="button"
            className="pp-employee-payroll-action-button pp-transparent-badge disabled"
            style={{ color: "#16a34a" }}
            disabled
          >
            HR Approved
          </button>
        );
      }
    }
  } else {
    // if (userApproval === "pending") {
    //   actionButton = (
    //     <button
    //       key="send-email"
    //       type="button"
    //       className={`pp-employee-payroll-action-button ${
    //         approvalRequestSent
    //           ? "pp-transparent-badge text-green"
    //           : "pp-blue-badge"
    //       }`}
    //       onClick={() => handleModalClick(row, "send_email")}
    //     >
    //       {approvalRequestSent ? "Email Sent" : "Send Email"}
    //     </button>
    //   );
    // } else
    if (stackholderApproval === "rejected") {
      actionButton = (
        <button
          key="stakeholder-rejected"
          type="button"
          className="pp-employee-payroll-action-button pp-transparent-badge disabled"
          style={{ color: "#dc2626" }}
          disabled
        >
          HR Rejected
        </button>
      );
    } else if (stackholderApproval === "approved") {
      actionButton = (
        <button
          key="stakeholder-approved"
          type="button"
          className="pp-employee-payroll-action-button pp-transparent-badge disabled"
          style={{ color: "#16a34a" }}
          disabled
        >
          HR Approved
        </button>
      );
    } else if (userApproval === "rejected") {
      actionButton = (
        <button
          key="user-rejected"
          type="button"
          className="pp-employee-payroll-action-button pp-transparent-badge disabled"
          style={{ color: "#dc2626" }}
          disabled
        >
          Staff Rejected
        </button>
      );
    } else if (stackholderApproval === "pending") {
      // (userApproval === "approved")
      // if (stackholderApproval === "pending") {
      actionButton = (
        <button
          key="approve"
          type="button"
          className="pp-employee-payroll-action-button pp-dark-badge"
          onClick={() => handleModalClick(row, "stakeholder")}
        >
          <ReviewIcon />
          Approve
        </button>
      );
      // }
    }
  }

  // if (!actionButton) {
  //   actionButton = (
  //     <button
  //       key="na"
  //       type="button"
  //       className="pp-employee-payroll-action-button pp-gray-badge disabled"
  //       disabled
  //     >
  //       <CrossIcon />
  //       NA
  //     </button>
  //   );
  // }

  return (
    <>
      {/* <div style={{ display: "flex", alignItems: "center" }}> */}
      {viewPayrollButton}
      {actionButton}
    </>
  );
};

export const discrepancyTabs = [
  { key: "pending", label: "Pending", count: 2 },
  { key: "approved", label: "Resolved", count: 1 },
  { key: "rejected", label: "Rejected", count: 0 },
];

export const processSteps = [
  {
    id: 1,
    title: "Payroll Generated",
    description: "Employee receives notification",
    number: 1,
    color: "blue",
  },
  {
    id: 2,
    title: "Review Period",
    description: "24-48 hours to accept/raise discrepancy",
    number: 2,
    color: "yellow",
  },
  {
    id: 3,
    title: "HR Review",
    description: "Discrepancies reviewed by HR",
    number: 3,
    color: "orange",
  },
  {
    id: 4,
    title: "Final Processing",
    description: "Payroll finalized on 7th, data frozen",
    number: 4,
    color: "green",
  },
];

export const getMonthName = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleDateString("en-US", { month: "long", year: "numeric" });
};

export const getDaysInMonth = (year, month) => {
  return new Date(year, month, 0).getDate();
};

export const getFirstDayOfMonth = (year, month) => {
  return new Date(year, month - 1, 1).getDay();
};

export const getFormattedDate = (payroll) => {
  if (payroll?.date) {
    return payroll.date;
  } else if (payroll?.month_year) {
    return `${payroll.month_year}-01`;
  }
  return "";
};

export const getAttendanceStatus = (dayData) => {
  if (!dayData) return "";

  // Leave
  if (dayData.is_leave_day === true) return "status-leave";

  // Weekoff
  if (dayData.is_weekoff === true) return "status-weekoff";

  // Weekend (separate classes)
  if (dayData.is_sunday === true) return "status-sunday";
  if (dayData.is_saturday === true) return "status-saturday";

  // Rostered
  if (dayData.is_rostered_day === true) return "status-rostered";

  // Half day
  if (dayData.is_half_day === true) return "status-half";

  // Late & present
  if (dayData.is_late === true && dayData.is_present === true)
    return "status-late";

  // Present/Absent
  if (dayData.is_present === true) return "status-present";
  if (dayData.is_absent === true) return "status-absent";

  return "";
};

export const truncateText = (text, maxLength = 50) => {
  if (!text || text.length <= maxLength) return text;
  return text.substring(0, maxLength) + "...";
};

export const discrepancyOptions = [
  { id: "present", label: "Present" },
  { id: "absent", label: "Absent" },
  { id: "halfday", label: "Half Day" },
  { id: "leave", label: "Leave" },
];

export const getFormLabels = (approvalType) => {
  if (approvalType === "staff") {
    return "Review Payrole";
  } else if (approvalType === "send_email") {
    return "Send Email to Staff";
  } else {
    return "HR Approval";
  }
};
